import { render, staticRenderFns } from "./UserAgeBreakdownSection.vue?vue&type=template&id=5bb24a9c&"
import script from "./UserAgeBreakdownSection.vue?vue&type=script&lang=js&"
export * from "./UserAgeBreakdownSection.vue?vue&type=script&lang=js&"
import style0 from "./UserAgeBreakdownSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports